<template>
  <div>
    <v-menu
        ref="menu1"
        v-model="menuColorPicker"
        :readonly="readonly"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="color"
        transition="scale-transition"
        offset-y
        :dark="$vuetify.theme.dark"
        content-class="v-sheet"
        min-width="290px">
      <template v-slot:activator="{ on }">
        <v-btn
            :disabled="readonly"
            icon
            v-on="on">
          <v-icon
              color="primary">
            palette
          </v-icon>
        </v-btn>
      </template>
      <v-color-picker
          v-model="color"
          :error="hasErrors"
          :readonly="readonly"
          :error-messages="errorMessages"
          show-swatches
          class="mx-auto" />
      <v-spacer />
      <div class="text-center pa-1">
        <v-btn
            id="cancelDateBtn"
            text
            color="primary"
            @click.stop="menuColorPicker = false">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="selectBtn"
            text
            color="primary"
            @click.stop="saveColor">
          {{ $t('Выбрать') }}
        </v-btn>
      </div>
    </v-menu>
  </div>
</template>

<script>
  // import BtnIconTip from './BtnIconTip.vue'
  export default {
    components: {
      // BtnIconTip
    },
    props: {
      value: {
        type: String,
        required: true
      },
      readonly: {
        type: Boolean,
        default: false
      },
      label: String,
      errorMessages: Array,
      required: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        menuColorPicker: false,
        color: null
      }
    },
    computed: {
      hasErrors () {
        return this.errorMessages && this.errorMessages.length > 0
      }
    },
    watch: {
      value: {
        immediate: true,
        handler (newValue) {
          if (newValue) {
            this.color = newValue
          }
        }
      }
    },
    methods: {
      saveColor: function () {
        this.$refs.menu1.save(this.color)
        this.updateValue()
      },
      updateValue: function () {
        if (!this.color) {
          return
        }
        // изменение поля (привязанного через дерективу v-model) в родительском компоненте
        this.$emit('input', this.color)
        // информируем родительский компонент, что дата поменялась, для запуска самописной обработки
        this.$emit('change')
      },
      clear: function () {
        this.color = null
        this.$emit('input', null)
      }
    }
  }
</script>
